export const CHECKOUT_LINKS = {
  megapack: 'https://www.centralpack.shop/cart/54026016457022:1',
  upsell: 'https://www.centralpack.shop/cart/54026014851390:1',
}
